var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63938 3.46812C8.63938 3.79865 8.3299 4.10812 7.99938 4.10812C7.65932 4.10812 7.35938 3.82255 7.35938 3.46812C7.35938 3.10427 7.63552 2.82812 7.99938 2.82812C8.3299 2.82812 8.63938 3.1376 8.63938 3.46812Z",
    fill: "#0245A9",
    stroke: "#0245A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35938 7.99938C7.35938 7.63552 7.63552 7.35938 7.99938 7.35938C8.3299 7.35938 8.63938 7.66885 8.63938 7.99938C8.63938 8.3299 8.3299 8.63938 7.99938 8.63938C7.65932 8.63938 7.35938 8.3538 7.35938 7.99938Z",
    fill: "#0245A9",
    stroke: "#0245A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35938 12.5306C7.35938 12.1668 7.63552 11.8906 7.99938 11.8906C8.3299 11.8906 8.63938 12.2001 8.63938 12.5306C8.63938 12.8611 8.3299 13.1706 7.99938 13.1706C7.65932 13.1706 7.35938 12.885 7.35938 12.5306Z",
    fill: "#0245A9",
    stroke: "#0245A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.a514703efa789ce4d2dedcf4d757e146.svg";
export { ForwardRef as ReactComponent };